import { useCallback, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import AnalyticsManager from '../../services/AnalyticsManager'
import { logFirebaseEvent } from '../firebaseConfig'
export const usePageTracking = () => {
  const location = useLocation()
  const { pathname, search } = location
  
  const getPath=useCallback(()=>{
    if(!pathname) return '/'
    else if(pathname==='/dashboard/profile') return '/profile'
    else return pathname
  },[pathname])

  useEffect(() => {
    const eventProps = {
      path: getPath(),
      search,
    }
    AnalyticsManager.trackTypedEvent({
      "event": 'Page View - Web',
      ...eventProps,
      "source": 'Web App'
    })
    
    logFirebaseEvent("page_view", eventProps);
  }, [search, getPath])
}